import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { PRODUCT } from '../data/constants';
export function SystemSection() {
  return <section className="bg-ice py-5 sm:py-7" data-id="element-162" data-mp="3biwp78cfpoea">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-163" data-mp="3bhllt9mwiinp">
        <h2 className="text-center text-2xl leading-tight text-navy sm:text-4xl" data-id="element-164" data-mp="36jsdob21feks">
          EVERYTHING YOU NEED.{' '}
          <span className="text-tech" data-id="element-165" data-mp="31l8q667spuqb">ONE COMPLETE NURSING CLINICAL VISUAL SYSTEM.</span>
        </h2>
        <p className="mt-1.5 text-center font-display text-sm font-semibold uppercase tracking-wide text-teal sm:text-lg" data-id="element-166" data-mp="2wtqrxpx5q891">
          6 Professional Nursing Modules In One Organized System
        </p>

        <div className="mx-auto mt-3 max-w-4xl rounded-xl border-2 border-navy bg-white p-3 text-center shadow-sm sm:p-5" data-id="element-167" data-mp="2nu3pr1wlsyex">
          <p className="font-heading text-lg font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-168" data-mp="2iswjj7a407ad">
            🩺 {PRODUCT}
          </p>
          <p className="mt-1.5 text-sm leading-snug text-steel sm:text-base" data-id="element-169" data-mp="13z80nibrr2u5">
            {PRODUCT} brings advanced patient assessment, injections, vascular access, wound care,
            medication safety, bedside procedures, and emergency recognition together in one
            complete professional visual reference system.
          </p>
          <p className="mx-auto mt-2 w-fit max-w-full rounded-lg bg-navy px-3 py-1 font-display text-2xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-170" data-mp="z16cwk3eefcc">
            ASSESS → <span className="text-tech-light" data-id="element-171" data-mp="1rpc2bk5ecsii">VISUALIZE</span> → VERIFY →{' '}
            <span className="text-tech-light" data-id="element-172" data-mp="1crjoqxjeue6y">MONITOR</span> → RECOGNIZE →{' '}
            <span className="text-tech-light" data-id="element-173" data-mp="1ctmcfax3bv8i">DOCUMENT</span>
          </p>
        </div>

        <div className="mt-3 grid gap-2 md:grid-cols-2 md:gap-2.5" data-id="element-174" data-mp="1horw0330sxtf">
          {modules.map(module => <article key={module.title} className="rounded-xl border border-metal bg-white p-3 shadow-sm sm:p-4" style={{
          borderLeft: `6px solid ${module.color}`
        }} data-id="element-175" data-mp="1eh7e09hlklq">
              <h3 className="flex items-start gap-1.5 text-sm leading-tight text-navy sm:text-base" data-id="element-176" data-mp="23z1ocv9wg8sv">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-177" data-mp="1z8bjdj5dy7yp" />
                {module.title}
              </h3>
              <p className="mt-1 text-sm leading-snug text-steel" data-id="element-178" data-mp="1paduqujm695k">{module.body}</p>
            </article>)}
        </div>
      </div>
    </section>;
}